<template>
  <app-admin>
    <div class="container content clearfix">
      <h1>Добавление новой группы</h1>
      <form @submit.prevent="save(false)" class="form form-sm">
        <div class="form-group">
          <label for="name">Название <sup>*</sup></label>
          <input type="text" id="name" v-model="group.name" autofocus
                 v-validate="'required'" name="название" data-vv-delay="500"
                 ref="firstInput">
          <p class="error" v-if="errors.has('название')">{{ errors.first('название') }}</p>
        </div>
        <!--<div class="form-group">-->
          <!--<label for="name">Тематика <sup>*</sup></label>-->
          <!--<select id="type" v-model="group.theme" v-validate="'required'" name="тематика" data-vv-delay="500">-->
            <!--<option value="" selected disabled>Выберите тематику</option>-->
            <!--<option v-for="theme in themes" :value="theme" :key="theme.id">-->
              <!--{{theme.name}}-->
            <!--</option>-->
          <!--</select>-->
          <!--<p class="error" v-if="errors.has('тематика')">{{ errors.first('тематика') }}</p>-->
        <!--</div>-->

        <transition name="fade">
          <div class="hint" v-if="showHint">
            <svg width="15" height="14">
              <path class="fil0"
                    d="M6.269 10.288l-3.364 -3.733c-0.212,-0.213 -0.504,-0.707 -0.99,-0.707 -0.695,0 -1.195,0.78 -0.742,1.395 0.235,0.317 0.728,0.788 0.978,1.112l3.631 4.031c0.443,0.354 1.011,0.28 1.376,-0.251 0.923,-1.344 1.935,-2.953 2.854,-4.328l3.345 -5.058c0.169,-0.254 0.237,-0.573 0.083,-0.894 -0.169,-0.351 -0.452,-0.491 -0.859,-0.491 -0.583,0 -0.951,0.817 -1.376,1.454l-4.936 7.47z"/>
            </svg>
            <span>Группа {{groupFull}} добавлена</span>
          </div>
        </transition>

        <div class="buttons-group-right">
          <router-link :to="{name: 'Groups'}">
            <div class="btn btn-light">Отмена</div>
          </router-link>
          <button type="submit" class="btn">Сохранить и добавить еще</button>
          <div class="btn" @click="save(true)">Сохранить</div>
        </div>
      </form>
    </div>

  </app-admin>
</template>

<script>
  import GroupsService from '@/services/GroupsService'

  export default {
    name: 'NewGroup',
    data () {
      return {
        group: {
          name: '',
          theme: ''
        },
        themes: [],
        groupFull: '',
        showHint: false
      }
    },
    methods: {
      save (goBack) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.groupFull = `${this.group.name}`
            this.group.theme = this.themes[0]
            let group = this.group
            group.theme = this.group.theme.id
            GroupsService.createGroup(group).then(
              (response) => {
                this.group = {
                  name: '',
                  theme: ''
                }
                this.$refs.firstInput.focus()
                this.showHint = true

                setTimeout(() => {
                  this.showHint = false
                  if (goBack) {
                    this.$router.push({name: 'Groups'})
                  }
                }, 1000)
              },
              (error) => {
                console.log(error)
              }
            )
          }
        })
      }
    },
    created () {
      GroupsService.getOrganizationThemes().then(
        (response) => {
          this.themes = response.results
        }
      )
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/groups/NewGroup.vue